import { Component, Input, Output, EventEmitter, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup} from '@angular/forms';
import { Base } from '../../models/base.model';
import { ColumnConfig } from '../../models/column-config.model';


@Component({
  selector: 'app-details-view',
  standalone: false,  
  templateUrl: './details-view.component.html',
  styleUrls: ['./details-view.component.scss']
})
export class DetailsViewComponent<T extends Base> implements OnInit {  
    private _showModal: boolean = false;
    @Input()
    get showModal(): boolean {
      return this._showModal;
    }
    set showModal(value: boolean) {     
      this._showModal = value;      
      this.showModalChange.emit(value); // Emit changes to the parent
    }
    @Output() showModalChange = new EventEmitter<boolean>();
    @Input() title = '';
    @Input() subTitle = '';
    @Input() model: T | null = null;
    @Input() columns: ColumnConfig [] = [];
    @Output() save = new EventEmitter<T>();
    @Output() delete = new EventEmitter<T>();   
    showConfirmDialog = false;

    form!: FormGroup;    

    constructor(private fb: FormBuilder) {}

    ngOnInit() {
      this.form = this.fb.group({});
        this.columns.forEach(column => {
          const syncValidators = column.validators ?? [];
          const asyncValidators = column.asyncValidators ?? [];
          this.form.addControl(
            column.name,
            this.fb.control(
              column.inputType === "checkbox" ? false : null,
              { 
                updateOn: column.updateOn ?? 'change', 
                validators: syncValidators,
                asyncValidators: asyncValidators
              } 
            )
          );          
        });
    }

    ngOnChanges(changes: SimpleChanges) {
      if (changes['model'] && this.model) {
          this.form.patchValue(this.model);
      }
    }

    openConfirmDialog() {
      if(this.form.invalid) {
        this.form.markAllAsTouched(); // Mark all fields as touched to trigger validation messages
        return;
      }          
      this.showConfirmDialog = true;
    }

    handleConfirm() {
      const updatedModel = { ...this.model, ...this.form.value };
      this.save.emit(updatedModel);
      this.showConfirmDialog = false;
      this.form.reset();
      this.closeModal();
    }

    handleCancel() {
      this.showConfirmDialog = false;
    } 
    
    closeModal() {
      this.showModal = false;
    }

    getObjectKeys(obj: any): string[] {
      return Object.keys(obj);
    }

    get valueChanges$() {
      return this.form?.valueChanges;
    }
}
